import asyncComponent from 'app/common/utils/async-component';
import { TOOL_CREATE_ROUTE, TOOL_EDIT_ROUTE } from '../ai/tool/constants';

const Workbench = asyncComponent(async () => import('./components'));

export default {
  '/api': {
    components: { main: Workbench },
    '/shape': {
      components: { main: Workbench },
      '/create': {
        components: { main: Workbench }
      },
      '/:name': {
        components: { main: Workbench }
      }
    },
    '/agent/edit/:name': {
      components: { main: Workbench }
    },
    '/agent/create': {
      components: { main: Workbench }
    },
    [TOOL_EDIT_ROUTE]: {
      components: { main: Workbench }
    },
    [TOOL_CREATE_ROUTE]: {
      components: { main: Workbench }
    },
    '/query/:name': {
      components: { main: Workbench }
    },
    '/mutation/:name': {
      components: { main: Workbench }
    }
  }
};
